module.exports = __webpack_public_path__ + "img/paint-05.4ce93522.png";